import { EVENT_TYPE } from './analytic.enum';
import { EventParams } from './analytic.interface';

/**
 * @description Analytics State.
 * @exports
 * @interface AnalyticState
 */
export interface AnalyticState {
  params: EventParams;
  name: EVENT_TYPE | undefined;
}

export const analyticKey = 'analytic';
export const analyticState: AnalyticState = {
  name: undefined,
  params: {}
};
